module.exports = __webpack_public_path__ + "img/userInfo1.502b2f38.png";